export default __webpack_public_path__ + "static/media/user_expired.73ed92d8.svg";